import { Example } from "./Example";

import styles from "./Example.module.css";

export type ExampleModel = {
    text: string;
    value: string;
};

const EXAMPLES: ExampleModel[] = [
    {
        text: "What are the holiday pay calculations?",
        value: "What are the holiday pay calculations?"
    },
    { text: "What are the criteria for receiving holiday pay?", value: "What are the criteria for receiving holiday pay?" },
    { text: "Are holidays allowed to roll?", value: "Are holidays allowed to roll?" }
];

interface Props {
    onExampleClicked: (value: string) => void;
}

export const ExampleList = ({ onExampleClicked }: Props) => {
    return (
        <ul className={styles.examplesNavList}>
            {EXAMPLES.map((x, i) => (
                <li key={i}>
                    <Example text={x.text} value={x.value} onClick={onExampleClicked} />
                </li>
            ))}
        </ul>
    );
};
